export const EMOCHA_APP = 'emocha://';
